<template>
  <zpa-form-group>

    <component :is="(item.type === 'contract' || item.type === 'attachInfo')?'zpaFormGroup':'zpaFormItem'" v-for="item in data[targetObj].components" :span="item.span?item.span:6" v-if="isItemShow(item)">


      <zpa-textarea autosize :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-if="item.type === 'textarea' && (!item.key.startsWith('default_'))" :label="item.label" v-model="data[targetObj][item.key]" :required="isItemReadRequired(item)" :max="item.max" :disabled="isItemReadOnly(item)"  />
      <zpa-textarea autosize :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'textarea' && (item.key.startsWith('default_'))" :label="item.label" v-model="data[dealItemDefaultKey(item.key)]" :required="isItemReadRequired(item)" :max="item.max" :disabled="isItemReadOnly(item)"  />

      <dictionary-select :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'dic' && (!item.key.startsWith('default_'))" :label="item.label"  v-model="data[targetObj][item.key]" :code="item.dicCode" :required="isItemReadRequired(item)" :multiple="item.dicMuti" :disabled="isItemReadOnly(item)"  />
      <dictionary-select :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'dic' && (item.key.startsWith('default_'))" :label="item.label"  v-model="data[dealItemDefaultKey(item.key)]" :code="item.dicCode" :required="isItemReadRequired(item)" :multiple="item.dicMuti" :disabled="isItemReadOnly(item)"  />

      <dictionary-cascader :getter="getdictionaryCascader" :number="false" :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'cascader' && (!item.key.startsWith('default_'))" :label="item.label"  :transform="true"   v-model="data[targetObj][item.key]" :code="item.dicCode" :required="isItemReadRequired(item)" :multiple="true" :disabled="isItemReadOnly(item)"  />
      <dictionary-cascader :getter="getdictionaryCascader" :number="false" :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'cascader' && (item.key.startsWith('default_'))" :label="item.label"  v-model="data[dealItemDefaultKey(item.key)]" :code="item.dicCode" :required="isItemReadRequired(item)" :multiple="true" :disabled="isItemReadOnly(item)"  />


      <zpa-number-input :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'number' && (!item.key.startsWith('default_'))" :label="item.label" v-model="data[targetObj][item.key]" :required="isItemReadRequired(item)" :max="item.max" :disabled="isItemReadOnly(item)"  />
      <zpa-number-input :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'number' && (item.key.startsWith('default_'))" :label="item.label" v-model="data[dealItemDefaultKey(item.key)]" :required="isItemReadRequired(item)" :max="item.max" :disabled="isItemReadOnly(item)"  />

      <zpa-date-input :type2="item.dicCode?item.dicCode:'date'" :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'date' && (!item.key.startsWith('default_'))" :label="item.label" v-model="data[targetObj][item.key]" :required="isItemReadRequired(item)"  :disabled="isItemReadOnly(item)" />
      <zpa-date-input :type2="item.dicCode?item.dicCode:'date'" :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'date' && (item.key.startsWith('default_'))" :label="item.label" v-model="data[dealItemDefaultKey(item.key)]" :required="isItemReadRequired(item)"  :disabled="isItemReadOnly(item)" />

      <zpa-text-editor :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'editor' && (!item.key.startsWith('default_'))" :label="item.label" v-model="data[targetObj][item.key]" :required="isItemReadRequired(item)" :disabled="isItemReadOnly(item)" />
      <zpa-text-editor :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.type === 'editor' && (item.key.startsWith('default_'))" :label="item.label" v-model="data[dealItemDefaultKey(item.key)]" :required="isItemReadRequired(item)" :disabled="isItemReadOnly(item)" />

      <Divider v-else-if="item.type === 'divider'" :orientation="item.dicCode?item.dicCode:'left'">{{ item.label }}</Divider>
      <Alert style="width: 100%" v-else-if="item.type === 'alert'" :type="item.dicCode?item.dicCode:'info'">{{ item.label }}</Alert>

<!--      <FormInfo v-else-if="item.type === 'contract'"  :data="data" :target-obj="item.key" :can-operate="canOperate" >{{ item.label }}</FormInfo>-->

      <AttachInfoForm v-else-if="item.type === 'attachInfo'" :file-list="data.attachfiles[item.key]" :need-upload="!isItemReadOnly(item)" >{{ item.label }}</AttachInfoForm>

      <zpa-text-input :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else-if="item.key.startsWith('default_')" :label="item.label" v-model="data[dealItemDefaultKey(item.key)]" :required="isItemReadRequired(item)" :max="item.max"  :disabled="isItemReadOnly(item)" />
      <zpa-text-input :label-width="item.labelWidth ?item.labelWidth:120" :placeholder="item.placeholder?item.placeholder:item.label" v-else :label="item.label" v-model="data[targetObj][item.key]" :required="isItemReadRequired(item)" :max="item.max"  :disabled="isItemReadOnly(item)" />

    </component>
  </zpa-form-group>
</template>

<script>
import AttachInfoForm from './AttachInfoForm'
export default {
  name: 'FormInfo',
  mixins: [

  ],
  components: {
    AttachInfoForm
  },
  data() {
    return {
    };
  },
  mounted() {

  },
  props:{
    data:{type:Object, default: () =>{}},
    targetObj:{ type:String ,default: 'formInfo'},
    canOperate: {type:Boolean, default:false},
    checkPublic: {type:Boolean, default:false},
  },
  methods: {
    isItemShow(item){
      if(this.checkPublic){
        if(!item.isPublic){
          return false
        }
      }
      if(item.isShow){
        return true
      }else {
        let strings = item.nodeCode.split(",");

        if(strings.some(p => p=== this.data.status)){
          item.isShow = true
          return true
        }else {
          item.isShow = false
          return false
        }
      }
    },
    isItemReadOnly(item) {
      if(!this.canOperate){
        return true
      }
      let strings = item.nodeCode.split(",");
      if(strings.some(p => p=== this.data.status)){
        return false
      }else {
        return true
      }
    },
    isItemReadRequired(item) {
      if(!this.canOperate){
        return false
      }

      let strings = item.nodeCode.split(",");
      if(strings.some(p => p=== this.data.status)){
        return item.required
      }
      return false
    },
    dealItemDefaultKey(key){
      return key.replace('default_','')
    },
    getdictionaryCascader(val){
      return  val ? val.split(',') : []
    }
  }

}
</script>
